var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewMenuCaseStudies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00977 1.29004C1.72852 1.36035 1.45898 1.55957 1.29492 1.8291L1.14258 2.0752L1.11914 23.0987L6.9082 28.9112L13.9746 28.8995C20.4317 28.8877 21.0528 28.876 21.1934 28.794C21.5332 28.6065 21.7676 28.3018 21.8262 27.9502L21.8614 27.7745H8.03321L8.00977 22.8291L7.85742 22.5713C7.76367 22.4073 7.62305 22.2666 7.44727 22.1612L7.18945 22.0088L4.72852 21.9971L2.25586 21.9854V2.37988H20.7481V13.8877H21.8731L21.8614 7.98145L21.8379 2.0752L21.6856 1.81738C21.5918 1.65332 21.4512 1.5127 21.2754 1.40723L21.0176 1.25488H11.6075C6.41602 1.25488 2.0918 1.2666 2.00977 1.29004Z",
    fill: "url(#paint0_linear_340_528)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.416 8.15723V11.6143H19.541V4.7002H18.416V8.15723Z",
    fill: "url(#paint1_linear_340_528)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95899 4.8527C4.86914 5.16911 3.9668 6.0363 3.63867 7.07926C3.56836 7.31364 3.49805 7.51286 3.49805 7.5363C3.49805 7.54801 4.13086 7.55973 4.9043 7.55973H6.31055V6.15348C6.31055 5.38005 6.31055 4.74723 6.29883 4.75895C6.28711 4.75895 6.13477 4.80583 5.95899 4.8527Z",
    fill: "url(#paint2_linear_340_528)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49495 6.36493V7.91181L9.69807 10.1149L9.86213 9.86884C10.1551 9.38837 10.284 8.9079 10.284 8.1579C10.284 7.33759 10.1551 6.90399 9.76838 6.29462C9.34651 5.65009 8.79573 5.20478 8.06917 4.93524C7.44807 4.70087 7.49495 4.57196 7.49495 6.36493Z",
    fill: "url(#paint3_linear_340_528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1426 8.75489V11.6143H17.2207V5.88379H16.1426V8.75489Z",
    fill: "url(#paint4_linear_340_528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8223 9.8916V11.626H14.9473V8.15723H13.8223V9.8916Z",
    fill: "url(#paint5_linear_340_528)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49805 8.77832C3.49805 8.79004 3.55664 9.00098 3.63867 9.23535C3.9668 10.2666 4.76367 11.0635 5.83008 11.4268C6.42774 11.626 7.27149 11.6377 7.84571 11.4502C8.15039 11.3565 8.73633 11.087 8.8418 10.9815C8.85352 10.9698 8.36133 10.4659 7.76367 9.85645L6.66211 8.75488H5.08008C4.21289 8.75488 3.49805 8.7666 3.49805 8.77832Z",
    fill: "url(#paint6_linear_340_528)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4902 10.4776V11.6143H12.6152V9.34082H11.4902V10.4776Z",
    fill: "url(#paint7_linear_340_528)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57617 15.6456V16.208H12.6387V15.083H4.57617V15.6456Z",
    fill: "url(#paint8_linear_340_528)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8107 15.1295C19.0138 15.2232 18.0763 15.5748 17.3732 16.0436C16.9279 16.3482 16.2248 17.0514 15.9201 17.4967C14.5724 19.5123 14.6662 22.1607 16.1779 24.0357C17.256 25.3717 18.756 26.0982 20.4904 26.0982C21.4396 26.0982 22.2951 25.8873 23.1154 25.442L23.3029 25.3365L25.0021 27.0357C26.6662 28.6881 26.7131 28.735 27.0178 28.817C27.7912 29.0397 28.5646 28.5592 28.7404 27.7623C28.7873 27.5162 28.7873 27.4107 28.7053 27.1412C28.6115 26.8248 28.5763 26.7897 26.9123 25.1139L25.2131 23.4147L25.3185 23.2272C26.0685 21.8326 26.1857 20.1803 25.6349 18.6568C24.8029 16.3248 22.342 14.8365 19.8107 15.1295ZM21.4513 16.5592C22.8693 16.9225 23.9826 17.9537 24.4396 19.3131C24.5568 19.6646 24.592 19.8639 24.6154 20.4264C24.6506 21.3053 24.5451 21.7389 24.1818 22.4889C23.9474 22.9576 23.8303 23.11 23.4201 23.5318C23.0099 23.942 22.8459 24.0592 22.3771 24.2936C21.6271 24.6686 21.1935 24.7623 20.3146 24.7272C19.5178 24.7037 19.0256 24.5631 18.381 24.1881C17.924 23.9186 17.1623 23.1568 16.9045 22.7232C15.4045 20.1803 16.9631 16.9342 19.8928 16.4772C20.3029 16.4186 21.0646 16.4537 21.4513 16.5592Z",
    fill: "url(#paint9_linear_340_528)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57617 17.9658V18.5283H12.6387V17.4033H4.57617V17.9658Z",
    fill: "url(#paint10_linear_340_528)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57617 20.2626V20.8017H12.6387V19.7236H4.57617V20.2626Z",
    fill: "url(#paint11_linear_340_528)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_528",
    x1: 3.73482,
    y1: -15.7914,
    x2: 28.1574,
    y2: -12.0439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_340_528",
    x1: 18.5578,
    y1: 0.43863,
    x2: 19.9113,
    y2: 0.483664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_340_528",
    x1: 3.85251,
    y1: 3.0324,
    x2: 7.10308,
    y2: 3.69981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_340_528",
    x1: 7.84576,
    y1: 1.52692,
    x2: 11.1678,
    y2: 1.8836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_340_528",
    x1: 16.2785,
    y1: 2.35174,
    x2: 17.5751,
    y2: 2.40162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_340_528",
    x1: 13.9641,
    y1: 6.01923,
    x2: 15.3132,
    y2: 6.1087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_340_528",
    x1: 4.17156,
    y1: 7.01126,
    x2: 9.77254,
    y2: 9.17477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_340_528",
    x1: 11.632,
    y1: 7.93956,
    x2: 12.9733,
    y2: 8.07528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_340_528",
    x1: 5.59231,
    y1: 14.3896,
    x2: 8.67767,
    y2: 18.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_340_528",
    x1: 16.7118,
    y1: 6.60009,
    x2: 32.664,
    y2: 9.86685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_340_528",
    x1: 5.59231,
    y1: 16.7099,
    x2: 8.67767,
    y2: 21.2313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_340_528",
    x1: 5.59231,
    y1: 19.0591,
    x2: 8.50123,
    y2: 23.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMenuCaseStudies);
export default __webpack_public_path__ + "static/media/new-menu-case-studies.7cb298411c676b2ae0f907c0cfb3b6f6.svg";
export { ForwardRef as ReactComponent };